<!--分页查询美育浸润-->
<template>
    <div class="practice-nav-content">
        <div class="practice-page-container" v-show="practiceMode==='practiceHome'">
            <div class="head-container">
                <div class="left-head-container">
                    <svg @click="backPage" t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">劳动实践主题活动</div>
                <div class="left-head-container">
                </div>
            </div>
            <!-- 六个年级 -->
            <div class="practice-grade-container">
                <div class="practice-grade-items">
                    <div class="practice-edu-items-top">
                        <div class="grade-item" @click="viewPracticePage('1','一年级')">
                            <img class="img-100" src="../../../assets/museum/nj1.png" alt="一年级">
                        </div>
                        <div class="grade-item" @click="viewPracticePage('2','二年级')">
                            <img class="img-100" src="../../../assets/museum/nj2.png" alt="二年级">
                        </div>
                        <div class="grade-item" @click="viewPracticePage('3','三年级')">
                            <img class="img-100" src="../../../assets/museum/nj3.png" alt="三年级">
                        </div>
                    </div>
                    <div class="practice-edu-items-bottom">
                        <div class="grade-item" @click="viewPracticePage('4','四年级')">
                            <img class="img-100" src="../../../assets/museum/nj4_new.jpg" alt="四年级">
                        </div>
                        <div class="grade-item" @click="viewPracticePage('5','五年级')">
                            <img class="img-100" src="../../../assets/museum/nj5_new.jpg" alt="五年级">
                        </div>
                        <div class="grade-item" @click="viewPracticePage('6','六年级')">
                            <img class="img-100" src="../../../assets/museum/nj6_new.jpg" alt="六年级">
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="practice-page-container" v-show="practiceMode==='practicePage'">
            <practice-page-home :item-key="this.itemKey"
                                :item-name="this.itemName"
                                :mark-info="this.markInfo"
                                @back-practice-page="backPracticePage"/>
        </div>
    </div>
</template>
<script>
import practicePageHome from "@/components/newMuseum/practice/practicePageHome.vue";
export default {
    name:'practiceHome',
    components:{
        practicePageHome
    },
    props:{},
    watch:{},
    mounted() {

    },
    data() {
        return {
            practiceMode:"practiceHome",
            itemKey:"",
            itemName:"",
            markInfo:"",
        }
    },
    methods: {
        backPage(){
            this.$emit('back-model-page', 'homePage');
        },
        backPracticePage(){
            this.practiceMode="practiceHome";
        },
        viewPracticePage(val,name){
            this.itemKey = val;
            this.itemName = name;
            this.markInfo = new Date();
            this.practiceMode="practicePage";
        }
    }
}
</script>
<style>
.practice-nav-content{
    width: 100%;
    height: auto;
}
.practice-page-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
    border-radius: 28px;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}

.practice-grade-container{
    width: 100%;
    height: calc(100% - 44px);
    align-items: center;
    justify-content: center;
    display: flex;

}
.practice-grade-items{
    width: 100%;
    height: calc(100% - 44px);
}
.practice-edu-items-top{
    width: 100%;
    height: 50%;
    padding: 0 0 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.practice-edu-items-bottom{
    width: 100%;
    height: 50%;
    padding: 10px 0 0 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.grade-item{
    width: auto;
    height: 100%;
    background-color: #fff;
    margin-left: 40px;
    cursor: pointer;
    box-shadow: var(--el-box-shadow);
    border: 1px solid #b1b1b1;
}
</style>